import UserCard from '@/model/userCard';
import { request } from '@/common/request';
import { isTestEnv } from '@/common/utils';
import { getLogger } from '@/common/logger';

const logger = getLogger('service-interface/user');


// 定义LimitWrite请求参数类型
interface LimitWriteParams {
  task_id: string;
  action: 1 | 2; // 1-曝光 2-点击 
  patg: string;
}
// 定义返回类型
interface UserModuleData {
  vipCard: any;
  sportCard: any;
  integralInfo: any;
  diamondsInfo: any;
  otherCard: any;
  iconInfo: any;
  userIdentity: string;
  vipIconList: any[];
  isFVip: boolean;
  userbasicReportInfo?: any;
  cardStyle?: any;
}
const hostPrefix = isTestEnv() ? 'testvip' : 'vip';

const getHeaders = () => {
  const isEvo = import.meta.env.EVO;
  if (!isEvo) return {};
  return {
    origin: 'https://v.qq.com',
    referer: 'https://v.qq.com',
  };
};

async function getPersonalCenterModule(): Promise<UserCard | UserModuleData> {
  const url = `https://${hostPrefix}.video.qq.com/rpc/trpc.video_pay_ffgn.personal_center_list.Service/GetModules`;
  
  const queryParams = {
    rpc_env: 3,
    rpc_data: JSON.stringify({ system: 501,  teen_flag: 4,  style_id: '3055' }),
  };
  try {
    const res = await request.get(
      url,
      queryParams,
      {
        withCredentials: true,
        timeout: 8000,
        // EVO必须添加该headers
        headers: getHeaders(),
      },
    );
    logger.log('获取用户信息', res);
    if ((res as any)?.data?.modules?.length || (res as any)?.status === 200) {
      return new UserCard((res as any).data.modules);
    }

    return {
      vipCard: {},
      sportCard: {},
      integralInfo: {},
      diamondsInfo: {},
      otherCard: {},
      iconInfo: {},
      userIdentity: 'no_vip',
      vipIconList: [],
      isFVip: false,
    };
  } catch (error) {
    logger.log(`触发错误${error}`);
    return {
      vipCard: {},
      sportCard: {},
      integralInfo: {},
      diamondsInfo: {},
      otherCard: {},
      iconInfo: {},
      userIdentity: 'no_vip',
      vipIconList: [],
      isFVip: false,
    };
  }
}


// 获取SVip信息
async function GetNewMsgCount(vuid: string): Promise<boolean> {
  try {
    const url = `https://${hostPrefix}.video.qq.com/rpc/trpc.hongji_group.web_message.WebMessageService/GetNewMsgCount`;
    const queryParams = {
      rpc_data: `{"vuid":${vuid},"platform":1}`,
    };
    console.log('打印GetNewMsgCount的params', queryParams);
    const res = await request.get(
      url,
      queryParams,
      {
        withCredentials: true,
        timeout: 8000,
        headers: getHeaders(),
      },
    );

    logger.log('获取vip消息', res);
    if ((res as any)?.data?.count > 0) {
      return true;
    }
    return false;
  } catch (error) {
      logger.error(`获取vip消息失败: ${error}`);
      return false;
  }
}

// 获取LimitWrite信息
async function getLimitWrite(params: LimitWriteParams): Promise<void> {
  try {
    const url = `https://${hostPrefix}.video.qq.com/rpc/trpc.vip_ad_promotion.promotion_limit_svr.Limit/LimitWrite`;
    const requestParams = {
      rpc_data: JSON.stringify({
        ...params,
        count: 1,
      }),
    };
    
    console.log('打印LimitWrite params', requestParams);
    const res = await request.get(
      url,
      requestParams,
      {
        withCredentials: true,
        timeout: 8000,
        headers: getHeaders(),
      },
    );

    logger.log('获取LimitWrite信息', res);
  } catch (error) {
    logger.error(`LimitWrite失败: ${error}`);
  }
}


export default {
  getPersonalCenterModule,
  GetNewMsgCount,
  getLimitWrite,
};
